export default {
  title: "Gestione Container",
  subtitle: "Panoramica cross-company di tutti i container con dati VIP",
  filters: {
    search: "Cerca container, booking, BL...",
    company: "Tutte le company",
    status: "Tutti gli stati",
  },
  table: {
    title: "Container",
    description: "Tutti i container della piattaforma",
    headers: {
      container: "Container",
      booking: "Booking",
      company: "Company",
      consignee: "Consignee",
      route: "Rotta",
      carrier: "Carrier / Nave",
      dates: "ETD / ETA",
      vip: "VIP %",
      risk: "Risk",
      status: "Stato",
      docs: "Docs",
    },
    empty: {
      title: "Nessun container trovato",
      message: "Prova a modificare i filtri di ricerca",
    },
  },
  detail: {
    title: "Dettaglio Container",
    vipFields: "Campi VIP",
    editFields: "Modifica campi",
    analyze: "Analizza con Agent",
    analyzing: "Analisi in corso...",
    save: "Salva modifiche",
    saving: "Salvataggio...",
    saved: "Modifiche salvate con successo",
    saveError: "Errore nel salvataggio",
    sources: "Fonti",
    confidence: "Certezza",
    noSources: "Nessuna fonte",
    fieldLabels: {
      container_number: "Numero Container",
      carrier: "Vettore",
      origin_port: "Porto Origine",
      destination_port: "Porto Destinazione",
      consignee_name: "Consignee",
      etd: "ETD",
      eta: "ETA",
      cargo_value: "Valore Carico",
      cargo_description: "Descrizione Merce",
      cargo_details: "Dettagli Carico",
      hs_code: "Codice HS",
    },
    status: {
      missing: "Mancante",
      uncertain: "Incerto",
      confirmed: "Confermato",
    },
    agentResult: "Risultato Agent",
    analyzeError: "Errore nell'analisi",
    decision: {
      CREATE: "Crea nuovo",
      LINK: "Collega esistente",
      REVIEW: "Necessita revisione",
      SKIP: "Ignora",
    },
  },
  loading: "Caricamento...",
};
